var _defs, _path, _path2, _path3, _path4, _path5, _path6, _polyline, _path7, _path8, _path9, _path10, _path11, _polyline2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _line, _line2, _line3, _path20, _path21, _path22, _path23;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPokemon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.4172,24.5955c.7657-.9358,6.4779-4.56,10.9586-4.1063,0,0-1.4015,4.73-10.3631,5.95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.59,23.4838c-.0425-.6607,3.3393-8.7644,7.4443-9.5939.5743,3.1266-3.4031,7.7634-4.339,8.5716"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.1643,22.738a6.31,6.31,0,0,0-3.6158,2.765,16.757,16.757,0,0,0-.9358,3.0416c-.1914.51-1.2549,1.9568-1.2124,2.9564s.4041,4.105,4.5942,5.4875,6.9126.6806,7.9548-.83a1.3544,1.3544,0,0,0-.7445-2.2545,1.8053,1.8053,0,0,0-2.2758,1.9142c-.0425,1.9131,2.3576,1.0237,2.3576,1.0237"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.7267,30.2349c.152-.3171,1.2334-.48,1.1483,1.4763s-.9318,1.849-1.26,1.1384"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.1592,26.2571c.5764,1.458,1.3,4.2017-.7423,8.0515"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.9366,22.2346c1.1629.0355,4.1567.4058,5.7758,2.0711"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "31.106 18.92 30.946 18.357 32.541 17.942"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.4138,19.7071l-.2127-.6912,1.8186-.787L33.0519,16.23a10.0363,10.0363,0,0,1,2.6268-1.1167l-.7019-2.648a23.9906,23.9906,0,0,1,7.4443-2.4992S42.8039,4.5846,43.123,3a48.801,48.801,0,0,0-6.5085,2.6374c-1.659,1.0209-4.9451,3.6052-4.9451,3.6052s1.8079,5.2,1.9249,5.3918l-2.446,1.2868,1.2234,2.0647"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.742,34.181a27.9593,27.9593,0,0,1-4.92,8.1958c-.9926.8224-2.9494,2.4814-3.474,2.51s-.5247-.0709-.5247-.0709L17.582,45l-.34-.2694-.61.1843-.1418-.6664s-.6664.156-.8366-.0709.6381-.9075.6381-.9075.1842-4.16,1.6448-5.54"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.3064,22.5688c1.09-1.9152,3.5362-4.1485,5.7482-4.5313s6.2532.2658,7.9016,1.978,3.2542,5.126,2.6587,7.2529-1.2868,2.999-2.6055,3.6583-5.2961,2.2175-6.5723,4.0865"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.518,32.4531c-.9259.551-3.5917,3.3723-3.9462,4.514"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.21,36.8467,4.877,37.4l.78.4538-.397.3828.5813.1135v.2836l.3687-.0709.1276.51h.468a6.4641,6.4641,0,0,0,.9783.1135c1.86.0058,4.9629-1.46,6.1469-2.2193"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "7.16 37.868 6.635 38.265 7.16 38.492"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.4607,36.3228a2.3861,2.3861,0,0,1,.2257-2.0142c.34-.4786.6169-.8614,1.0742-.8295a3.2448,3.2448,0,0,1,2.1907,2.9139,1.1469,1.1469,0,0,1-.775.9411"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.3214,35.7549c.2568-.6531,2.2676-1.4528,2.7729-1.4073"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.2857,18.6868c1.067.0951,4.859,1.0483,6.3342,2.1882"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31.4554,23.0953a6.4867,6.4867,0,0,1,.6607,2.62"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M29.2872,27.9278A11.89,11.89,0,0,0,27.66,25.3036"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.77,22.9176c-.5661-.4135-3.8444-.61-5.0539-.5624"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M29.41,20.9325a6.42,6.42,0,0,1-.7586,3.9542"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.6966,16.1051c.5305.0607,1.3809,1.3928,1.4023,3.4492"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 20.51,
    y1: 30.5461,
    x2: 17.454,
    y2: 31.5883
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 11.9597,
    y1: 27.6535,
    x2: 12.9664,
    y2: 30.3533
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 13.399,
    y1: 32.054,
    x2: 13.7078,
    y2: 32.2029
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.766,31.4819c-.1167.3936-.1061,1.9143,1.1063,1.9143s1.3187-.9252,1.3187-1.4676a1.286,1.286,0,0,0-.5819-1.0752"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.25,28.4325a1.2711,1.2711,0,0,0-.8541,1.3351c.0319.4595.3935,1.074.7763,1.0858s.6929-.4891.6655-.8448"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34.2005,30.0972a8.94,8.94,0,0,1,1.0953.7126l-.117.2765.4148.5423.4786-.7657"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M35.2865,28.2858s1.1366,1.5349,1.2111,1.7583a5.3694,5.3694,0,0,1,0,1.106l-.7559.2416"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPokemon);
export default __webpack_public_path__ + "static/media/pokemon.9156282bfa824851fcbbb23a9e1ddc16.svg";
export { ForwardRef as ReactComponent };